import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { AddUserComponent } from './add-user/add-user.component';
import { ApiService } from '../../api.service';
import { BulkImportComponent } from './bulk-import/bulk-import.component';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdatePictureComponent } from './update-picture/update-picture.component';
import { ManageGroupsComponent } from './manage-groups/manage-groups.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PaginationModel } from '../../models/paginationModel';
import { OkModalComponent } from '../../generic-components/ok-modal/ok-modal.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.css'],
    providers: [NgxSpinnerService]
})
export class UserManagementComponent implements OnInit {
    displayedColumns: string[] = ['profileFirstName', 'email', 'profilePhoneNumber', 'role', 'status', 'actions'];
    dataSource = new MatTableDataSource<any>();
    totalLength = 0;
    active = "ProfileFirstName";
    direction = "ASC";
    pageIndex = 0;
    pageSize = 5;
    filter = "";
    userStatus = 2;
    filterApplied = false;
    scrHeight: any;
    scrWidth: any;
    roles:any;
    rFilter = "select_role";
    roleFilter = "select_role";
    errors = ["invalid_role","unresolved_alerts"];

    //@ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    constructor(
        private apiService: ApiService, 
        public functionsService:FunctionsService, 
        public translate:TranslateService,
        private modalService: NgbModal,
        private spinner: NgxSpinnerService,
        public pagination:PaginationModel,
        private router: Router
    ) { 
        this.functionsService.setTitle('user.users');
        this.getScreenSize();
        if(this.router.url==='/'){
            this.router.navigateByUrl('main/activeAlerts');
        }
    }

    ngOnInit(): void {
        this.getScreenSize();
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
       // this.dataSource.sort = this.sort;
        this.translate.onLangChange.subscribe(() => {
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
            }
        });
        this.fetchRoles();
        this.fetchUsers();
    }

    private fetchUsers() {
        if(!this.filterApplied){
            this.clearFilter();
        }
        this.spinner.show();
        this.pagination.Page = this.pageIndex;
        this.pagination.PageSize = this.pageSize;
        this.pagination.OrderBy = this.active;
        this.pagination.Order = this.direction;
        this.pagination.Filter = this.filter;
        this.pagination.Role = this.rFilter;
        this.pagination.Status = this.userStatus;
        this.apiService.getUsersPagination(this.pagination).subscribe(resp => {
            this.dataSource.data = Object.values(resp)[0];
            this.totalLength = parseInt(Object.keys(resp)[0]);
            const paginatorLabel = document.getElementsByClassName("mat-paginator-page-size-label")[0];
            if (paginatorLabel) {
                paginatorLabel.innerHTML = this.translate.instant("paginator.items_per_page");
            }
            this.spinner.hide();
            
        }, error => {
            this.functionsService.errorHandler(error["status"]);
            this.spinner.hide();
        });
    }

    fetchRoles() {
        this.apiService.getRoles().subscribe(resp => {
            this.roles = resp;
        }, err => {
            console.error(err);
        });
    }

    changeUserStatus(user) {
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        if ([0,4,5].includes(user.active)) {
            confirmModalRef.componentInstance.title = this.translate.instant("general.activate");
            confirmModalRef.componentInstance.message = this.translate.instant("user.activate") + `${user.profileFirstName} ` + `${user.profileLastName}` + ` (${user.email})?`;
        }else if(user.active == 6) {
            confirmModalRef.componentInstance.title = this.translate.instant("general.restore");
            confirmModalRef.componentInstance.message = this.translate.instant("user.restore") + `${user.profileFirstName} ` + `${user.profileLastName}` + ` (${user.email})?`;
        }
        else {
            confirmModalRef.componentInstance.title = this.translate.instant("general.inactivate");
            confirmModalRef.componentInstance.message = this.translate.instant("user.inactivate") + `${user.profileFirstName} ` + `${user.profileLastName}` + ` (${user.email})?`;
        }
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                switch(user.active){
                    case 1:
                        user.active = 0;
                        break;
                    case 2:
                        user.active = 4;
                        break;
                    case 3:
                        user.active = 5;
                        break;
                    case 4:
                        user.active = 2;
                        break;
                    case 5:
                        user.active = 3;
                        break;
                    default:
                        user.active = 1;
                        break;
                }
                this.apiService.changeUserStatus(user).subscribe(
                    () => {
                        this.spinner.hide();
                        this.fetchUsers();
                    },
                    error => {
                        switch(user.active){
                            case 1:
                                user.active = 0;
                                break;
                            case 2:
                                user.active = 3;
                                break;
                            case 3:
                                user.active = 2;
                                break;
                            default:
                                user.active = 1;
                                break;
                        }
                        if(this.errors.includes(error["error"]["content"])){
                            const modalRef = this.modalService.open(OkModalComponent);
                            modalRef.componentInstance.title = this.translate.instant('Error');
                            modalRef.componentInstance.message = this.translate.instant(error["error"]["content"]);
                        }else{
                            this.functionsService.errorHandler(error["status"]);
                        }
                        this.spinner.hide();
                    }
                );
            }
        });
    }

    addUserBtnClick() {
        const addUserModalRef = this.modalService.open(AddUserComponent, { size: 'xl'});
        addUserModalRef.result.then(() => this.fetchUsers());
    }

    bulkImportBtnClick() {
        const bulkUserModalRef = this.modalService.open(BulkImportComponent, { size: 'xl'});
        bulkUserModalRef.result.then(() => this.fetchUsers());
    }

    changePicture(user) {
        const changePictureModalRef = this.modalService.open(UpdatePictureComponent);
        changePictureModalRef.componentInstance.userToChangePicture = user;
        changePictureModalRef.result.then(() => this.fetchUsers());
    }

    deleteUser(user) {
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant("user.delete_user");
        confirmModalRef.componentInstance.message = this.translate.instant("user.delete_prompt") + `${user.profileFirstName} ` + `${user.profileLastName}` + ` (${user.email})?`;
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.userDeletionConfirmed(user);
            }
        });
    }

    async userDeletionConfirmed(user) {
        this.spinner.show();
        (await this.apiService.deleteUser(user.id)).subscribe(
            async () => {
                this.fetchUsers();
                this.spinner.hide();
            },
            error => {
                if(this.errors.includes(error["error"]["content"])){
                    const modalRef = this.modalService.open(OkModalComponent);
                    modalRef.componentInstance.title = this.translate.instant('Error');
                    modalRef.componentInstance.message = this.translate.instant(error["error"]["content"]);
                }else{
                    this.functionsService.errorHandler(error["status"]);
                }
                this.spinner.hide();
            }
        );
    }

    resendPasswordPrompt(user){
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('user.resend_invitation');
        confirmModalRef.componentInstance.message = this.translate.instant('user.resend_invitation_prompt') + `"${user.email}"`+"?";

        this.translate.onLangChange.subscribe(() => {
            confirmModalRef.componentInstance.title = this.translate.instant('user.resend_invitation');
            confirmModalRef.componentInstance.message = this.translate.instant('user.resend_invitation_prompt') + `"${user.email}"`+"?";
        });

        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.resendPassword(user);
            }
        });
    }

    resendPassword(user) {
        this.spinner.show();
        this.apiService.resendPassword(user).subscribe(
            () => {
                this.spinner.hide();
                const modalRef = this.modalService.open(OkModalComponent);
                modalRef.componentInstance.title = this.translate.instant('user.info_sent');
                modalRef.componentInstance.message = this.translate.instant('user.info_sent_message') + '"' + user.email + '".';
        
                modalRef.result.then(() => {
                    this.modalService.dismissAll();
                }); 
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    resetPasswordPrompt(user){
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('password.reset_pass');
        confirmModalRef.componentInstance.message = this.translate.instant('user.reset_password_prompt') + `"${user.email}"`+"?";

        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.resetPassword(user);
            }
        });
    }

    resetPassword(user) {
        this.spinner.show();
        this.apiService.resetUserPassword(user).subscribe(
            () => {
                this.spinner.hide();
                const modalRef = this.modalService.open(OkModalComponent);
                modalRef.componentInstance.title = this.translate.instant('user.password_reset');
                modalRef.componentInstance.message = this.translate.instant('user.password_reset_message') + '"' + user.email + '".';

                modalRef.result.then(() => {
                    this.modalService.dismissAll();
                }); 
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    viewGroups(user) {
        const manageGroupsModalRef = this.modalService.open(ManageGroupsComponent, { size: 'xl' });
        manageGroupsModalRef.componentInstance.userId = user.id;
        manageGroupsModalRef.componentInstance.userName = user.profileFirstName + " " + user.profileLastName;
        manageGroupsModalRef.componentInstance.status = user.active;
        manageGroupsModalRef.result.then(() => this.fetchUsers());  
    }

    async viewUser(user) {
        this.spinner.show();
        (await this.apiService.getUserProfile(user.id)).subscribe(
            data => {
                this.spinner.hide();
                const modalRef = this.modalService.open(ViewUserComponent, { size: 'xl' });
                modalRef.componentInstance.userToView = data;
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    nextPage(evt){
        this.pageIndex = evt.pageIndex;
        this.pageSize = evt.pageSize;
        this.fetchUsers();
    }

    sortData(evt){
        this.active = evt.active;
        this.direction = evt.direction;
        this.fetchUsers();
    }

    changeRoleLabel(role: string) {
        this.rFilter = role;
        this.roleFilter = role;
    }

    statusObject = {"active":1, "deleted":6, "inactive":0,};
    statusFilter: string = "select_status";
    statuses: string[] = Object.keys(this.statusObject);
    changeStatusFilterLabel(status) {
        this.statusFilter = status;
        this.userStatus = this.statusObject[status];
    }

    applyFilter() {
        this.pageIndex = 0;
        this.filter = (<HTMLInputElement>document.getElementById("filter")).value;
        this.filter = this.filter.trim().toLowerCase();
        this.filterApplied = true;
        this.fetchUsers();
    }

    clearFilter(){
        this.filter = "";
        this.rFilter = "select_role";
        this.roleFilter = "select_role";
        this.userStatus = 2;
        this.statusFilter = "select_status";
        if((<HTMLInputElement>document.getElementById("filter"))){
            (<HTMLInputElement>document.getElementById("filter")).value = "";
        }
    
        if(this.filterApplied){
            this.filterApplied = false;
            this.fetchUsers();
        }
    }

    emptyInput(){
        if((<HTMLInputElement>document.getElementById("filter")).value == ""){
            this.filter = "";
            this.fetchUsers();
        }
    }

    @HostListener('window:resize', [])
    getScreenSize() {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
        this.displayedColumns = ['profileFirstName', 'email', 'profilePhoneNumber', 'role', 'status', 'actions'];
        
        if(this.scrWidth <= 375){
            this.displayedColumns = ['profileFirstName', 'actions'];
        }
        else if(this.scrWidth <= 440){
            this.displayedColumns = ['profileFirstName', 'email', 'actions'];
        }
        else if(this.scrWidth <= 600){
            this.displayedColumns = ['profileFirstName', 'email', 'role', 'status', 'actions'];
        }
    }
}